import dayjs from "dayjs";
import {
  ANALYTICS_BY_MONTH_LOADING,
  SUBMIT_ANALYTICS_BY_MONTH_ACTION_DISPATCHER,
  SUBMIT_ANALYTICS_BY_MONTH_ACTION_REQUESTED,
  SUBMIT_ANALYTICS_BY_MONTH_ERROR_DISPATCHER,
} from "./Action";

const initialState = {
  successData: { chartData: [], excelData: [], apiData: {} },
  failureData: {},
  loading: false,
  isLogout: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_ANALYTICS_BY_MONTH_ACTION_REQUESTED:
      return { ...state, loading: true };
    case SUBMIT_ANALYTICS_BY_MONTH_ACTION_DISPATCHER:
      const tempArr = [["Page Title", "Percentage", { role: "annotation" }]];
      const tempExcelArr = [["Page Title", "Percentage"]];
      action.payload.data.data.forEach((e) => {
        tempArr.push([
          e.page_url,
          parseFloat(e.percentage.toFixed(1)),
          `${e.percentage.toFixed()}`,
        ]);
        tempExcelArr.push([
         e.page_url,
          parseFloat(e.percentage.toFixed(1)),
        ]);
      });
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const sorter = (a, b) => {
        a = a[0].toString().split("/");
        b = b[0].toString().split("/");
        if (a[1] !== b[1]) {
          return a[1] - b[1];
        } else {
          return months.indexOf(a[0]) - months.indexOf(b[0]);
        }
      };
      tempArr.sort(sorter);
      tempExcelArr.sort(sorter);
      // tempArr.sort(function (a, b) {
      //   return a[1] - b[1] || a[0] - b[0];
      // });
      return {
        ...state,
        successData: { chartData: tempArr, excelData: tempExcelArr, apiData: action.payload.data },
        loading: false,
      };
    case SUBMIT_ANALYTICS_BY_MONTH_ERROR_DISPATCHER:
      return {
        ...state,
        formError: action.payload,
        loading: false,
      };
    case ANALYTICS_BY_MONTH_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
